/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RequestFormViewModel,
    RequestFormViewModelFromJSON,
    RequestFormViewModelFromJSONTyped,
    RequestFormViewModelToJSON,
} from './RequestFormViewModel';

/**
 * 
 * @export
 * @interface RequestFormViewModelPagedDataModel
 */
export interface RequestFormViewModelPagedDataModel {
    /**
     * 
     * @type {number}
     * @memberof RequestFormViewModelPagedDataModel
     */
    pageNo?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestFormViewModelPagedDataModel
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestFormViewModelPagedDataModel
     */
    readonly rowIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestFormViewModelPagedDataModel
     */
    readonly pageCount?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestFormViewModelPagedDataModel
     */
    itemCount?: number;
    /**
     * 
     * @type {Array<RequestFormViewModel>}
     * @memberof RequestFormViewModelPagedDataModel
     */
    data?: Array<RequestFormViewModel> | null;
}

export function RequestFormViewModelPagedDataModelFromJSON(json: any): RequestFormViewModelPagedDataModel {
    return RequestFormViewModelPagedDataModelFromJSONTyped(json, false);
}

export function RequestFormViewModelPagedDataModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestFormViewModelPagedDataModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pageNo': !exists(json, 'pageNo') ? undefined : json['pageNo'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'rowIndex': !exists(json, 'rowIndex') ? undefined : json['rowIndex'],
        'pageCount': !exists(json, 'pageCount') ? undefined : json['pageCount'],
        'itemCount': !exists(json, 'itemCount') ? undefined : json['itemCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(RequestFormViewModelFromJSON)),
    };
}

export function RequestFormViewModelPagedDataModelToJSON(value?: RequestFormViewModelPagedDataModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pageNo': value.pageNo,
        'pageSize': value.pageSize,
        'itemCount': value.itemCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(RequestFormViewModelToJSON)),
    };
}

